// textarea-counter.js - Clean module for textarea counters

// Track if global listeners are already set up
let globalTextareaCounterListenersInitialized = false;

function setupTextareaCounters() {
  // Only set up global listeners once
  if (!globalTextareaCounterListenersInitialized) {
    setupGlobalEventListeners();
    globalTextareaCounterListenersInitialized = true;
  }

  const textareaContainers = document.querySelectorAll(".textarea-fs");
  textareaContainers.forEach(function (container) {
    const textarea = container.querySelector("textarea");
    const charCounter = container.querySelector(
      '.toolbar input[name="textarea-chars-counter"]',
    );
    const resizeButton = container.querySelector(
      ".toolbar a.textarea-resize-button",
    );
    if (!textarea || !charCounter || !resizeButton) {
      return;
    }

    const maxLength = textarea.getAttribute("maxlength");
    if (maxLength) {
      charCounter.value = maxLength;
      updateCharCounter(textarea, charCounter, maxLength);
    }
  });
}

function setupGlobalEventListeners() {
  document.addEventListener("input", function (e) {
    if (e.target.tagName === "TEXTAREA" && e.target.closest(".textarea-fs")) {
      const container = e.target.closest(".textarea-fs");
      const textarea = e.target;
      const charCounter = container.querySelector(
        '.toolbar input[name="textarea-chars-counter"]',
      );
      const maxLength = textarea.getAttribute("maxlength");
      if (charCounter && maxLength) {
        updateCharCounter(textarea, charCounter, maxLength);
      }
    }
  });

  document.addEventListener("click", function (e) {
    if (e.target.closest(".textarea-resize-button")) {
      e.preventDefault();
      const resizeButton = e.target.closest(".textarea-resize-button");
      const container = resizeButton.closest(".textarea-fs");
      toggleExpand(e, container, resizeButton);
    }
  });
}

function updateCharCounter(textarea, charCounter, maxLength) {
  const remainingChars = maxLength - textarea.value.length;
  charCounter.value = remainingChars;
  if (remainingChars < 100) {
    charCounter.classList.add("warning");
  } else {
    charCounter.classList.remove("warning");
  }
}

function toggleExpand(e, container, resizeButton) {
  e.preventDefault();
  container.classList.toggle("expand");
  if (container.classList.contains("expand")) {
    resizeButton.setAttribute("title", "Collapse");
    const backdrop = document.createElement("div");
    backdrop.className = "modal-backdrop fade show textarea-backdrop";
    document.body.appendChild(backdrop);
    document.body.classList.add("modal-open");
    backdrop.addEventListener("click", function () {
      toggleExpand({ preventDefault: () => {} }, container, resizeButton);
    });
    document.addEventListener("keydown", function escKeyHandler(e) {
      if (e.key === "Escape") {
        e.preventDefault();
        e.stopPropagation();
        toggleExpand({ preventDefault: () => {} }, container, resizeButton);
        document.removeEventListener("keydown", escKeyHandler);
      }
    });
  } else {
    resizeButton.setAttribute("title", "Expand");
    const backdrop = document.querySelector(".textarea-backdrop");
    if (backdrop) {
      backdrop.remove();
    }
    document.body.classList.remove("modal-open");
  }
}

// Export the setup function directly
export default setupTextareaCounters;
